import(/* webpackMode: "eager", webpackExports: ["LiveGameCardWrapper"] */ "/vercel/path0/components/lol/LiveGameCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServerMap"] */ "/vercel/path0/components/ServerMap.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/lib/image-loader.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
